var render = function render(){
  var _this = this;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('div', [_vm._v(" " + _vm._s(_vm.$t('template.batch-opening-times.loading')) + " ")]) : _c('div', [_vm.showHeader ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('template.batch-opening-times.title')))])]), _c('div', {
    staticClass: "col-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-link p-0",
    attrs: {
      "title": _vm.$t('template.batch-opening-times.close-button')
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('h2', [_vm._v("×")])])])]) : _vm._e(), _c('div', {
    staticClass: "card my-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('strong', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('template.batch-opening-times.locations-title')))]), _vm._l(_vm.locationTypes, function (locationType) {
    return _c('table', {
      staticClass: "table table-sm table-striped col-4"
    }, _vm._l(['1', '0'], function (isActive) {
      return _vm.getCount(_vm.locationsByType[locationType.id], 'active', isActive) ? _c('tr', [_c('td', [_vm._v(" " + _vm._s(locationType.display_name) + " "), isActive === '1' ? _c('span', [_vm._v("(" + _vm._s(_vm.$t('template.batch-opening-times.active')) + ")")]) : _c('span', [_vm._v("(" + _vm._s(_vm.$t('template.batch-opening-times.inactive')) + ")")])]), _c('td', {
        staticClass: "col-3"
      }, [_vm._v(_vm._s(_vm.getCount(_vm.locationsByType[locationType.id], 'active', isActive)))])]) : _vm._e();
    }), 0);
  })], 2)]), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('strong', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('template.batch-opening-times.service-type')))]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.serviceTypeIdentifier,
      expression: "serviceTypeIdentifier"
    }],
    staticClass: "form-control form-control-sm",
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.serviceTypeIdentifier = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, _vm._l(_vm.serviceTypes, function (serviceType) {
    return _c('option', {
      domProps: {
        "value": serviceType.identifier
      }
    }, [_vm._v(_vm._s(serviceType.display_name))]);
  }), 0), _c('b-checkbox', {
    staticClass: "d-inline-block mr-1",
    attrs: {
      "switch": "",
      "id": "overwriteConflictingServiceTimes",
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: _vm.overwriteConflictingServiceTimes,
      callback: function ($$v) {
        _vm.overwriteConflictingServiceTimes = $$v;
      },
      expression: "overwriteConflictingServiceTimes"
    }
  }), _c('label', {
    staticClass: "form-check-label line-height-200",
    attrs: {
      "for": "overwriteConflictingServiceTimes"
    }
  }, [_vm._v(_vm._s(_vm.$t('template.batch-opening-times.overwrite-conflicts')))])], 1)])])]), _c('div', {
    staticClass: "card mb-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [!_vm.isSaved ? _c('span', [_c('strong', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('template.batch-opening-times.add-service-time-title')))]), _c('br'), _vm.overwriteConflictingServiceTimes ? _c('small', [_c('em', [_c('strong', [_vm._v(_vm._s(_vm.$t('template.batch-opening-times.watch-out')))]), _vm._v(" " + _vm._s(_vm.$t('template.batch-opening-times.location-overwrite-state-on-prefix')) + " "), _c('strong', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('template.batch-opening-times.location-overwrite-state-on')))]), _vm._v(". ")])]) : _c('small', [_c('em', [_c('strong', [_vm._v(_vm._s(_vm.$t('template.batch-opening-times.watch-out')))]), _vm._v(" " + _vm._s(_vm.$t('template.batch-opening-times.location-overwrite-state-off-prefix')) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('template.batch-opening-times.location-overwrite-state-off')))]), _vm._v(". ")])])]) : _c('strong', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('template.batch-opening-times.service-time-added')))]), _c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "row my-2"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('template.batch-opening-times.date')))]), _c('div', {
    staticClass: "col pl-1"
  }, [_vm._v(_vm._s(_vm.$t('template.batch-opening-times.status')))]), !_vm.useCutOff ? _c('div', {
    staticClass: "col pl-1"
  }, [_vm._v(_vm._s(_vm.$t('template.batch-opening-times.from')))]) : _vm._e(), !_vm.useCutOff ? _c('div', {
    staticClass: "col pl-1"
  }, [_vm._v(_vm._s(_vm.$t('template.batch-opening-times.to')))]) : _vm._e(), _vm.useCutOff ? _c('div', {
    staticClass: "col pl-1"
  }, [_vm._v(_vm._s(_vm.$t('template.batch-opening-times.cutoff')))]) : _vm._e(), _c('div', {
    staticClass: "col pl-1"
  }, [_vm._v(_vm._s(_vm.$t('template.batch-opening-times.description')))]), _c('div', {
    staticClass: "col pl-1"
  })]), _c('location-service-time-form', {
    attrs: {
      "date": true,
      "create": true,
      "use-cut-off": !!_vm.useCutOff,
      "read-only": _vm.isSaving || _vm.isSaved
    },
    on: {
      "validated": function () {
        return _this.isNewServiceTimeValid = arguments.length <= 0 ? undefined : arguments[0];
      }
    },
    model: {
      value: _vm.newServiceTimeByDate,
      callback: function ($$v) {
        _vm.newServiceTimeByDate = $$v;
      },
      expression: "newServiceTimeByDate"
    }
  }, [!_vm.isSaved ? _c('button', {
    staticClass: "btn btn-sm w-100",
    class: {
      'btn-outline-secondary': !_vm.isNewServiceTimeValid,
      'btn-success': _vm.isNewServiceTimeValid
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.isNewServiceTimeValid || _vm.isSaving,
      "title": _vm.addServiceTimeTooltip
    }
  }, [_vm._v(_vm._s(_vm.$t('template.batch-opening-times.save')) + " "), _vm.isSaving ? _c('span', [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1) : _vm._e()]) : _vm._e()]), _vm.isSaved ? _c('button', {
    staticClass: "btn btn-primary mt-4",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v(_vm._s(_vm.$t('template.batch-opening-times.add-another')))]) : _vm._e()], 1)]), _vm.successCount ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v(" " + _vm._s(_vm.$t('template.batch-opening-times.count-added')) + " " + _vm._s(_vm.successCount) + " ")]) : _vm._e(), _vm.generalError ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(" " + _vm._s(_vm.$t('template.batch-opening-times.count-ignored')) + " " + _vm._s(_vm.generalError) + " ")]) : _vm._e(), _vm.locationErrorList.length ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(" " + _vm._s(_vm.$t('template.batch-opening-times.list-errors')) + " "), _c('ul', {
    staticClass: "list-unstyled"
  }, _vm._l(_vm.locationErrorList, function (error) {
    return _c('li', {}, [_c('router-link', {
      attrs: {
        "tag": "a",
        "target": "_blank",
        "to": {
          name: 'locationEditServiceTimes',
          params: {
            locationTypeIdentifier: _vm.locationTypes[error.location.location_type_id].identifier,
            locationIdentifier: error.location.identifier,
            serviceTypeIdentifier: _vm.serviceTypeIdentifier
          }
        }
      }
    }, [_vm._v(" " + _vm._s(error.location.display_name) + " ")]), _vm._v(": " + _vm._s(error.message) + " ")], 1);
  }), 0)]) : _vm._e()])]);

}
var staticRenderFns = []

export { render, staticRenderFns }